import React from "react";
import Swal from "sweetalert2";
import axios from "axios";

const EditUomModal = ({ isOpen, onClose, editFormData, setEditFormData, fetchData, branch }) => {
  if (!isOpen) return null;

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleEditSubmit = async (e) => {
  e.preventDefault();

  // === Validation: UOM Name ===
  if (!editFormData.name || editFormData.name.trim() === "") {
    Swal.fire({
      icon: "warning",
      title: "Validation Error",
      text: "UOM Name should not be empty.",
    });
    return;
  }

  // === Validation: Long Name ===
  if (!editFormData.longName || editFormData.longName.trim() === "") {
    Swal.fire({
      icon: "warning",
      title: "Validation Error",
      text: "Long Name should not be empty.",
    });
    return;
  }

  try {
    Swal.fire({
      title: "Submitting...",
      text: "Please wait while we process your request.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const response = await axios.put(
      `https://rfs2.infraconsoft.net.in/api/uomMaster_update/${editFormData.code}`,
      {
        name: editFormData.name,
        branch: branch,
        code: editFormData.code,
        longName: editFormData.longName,
      }
    );

    if (response.data.success) {
      Swal.fire({
        icon: "success",
        title: "Updated!",
        text: "Updated successfully.",
      });
      onClose();
      fetchData();
    }
  } catch (error) {
    console.error("Error updating category:", error);

    if (error.response && error.response.status === 400) {
      Swal.fire({
        icon: "error",
        title: "Already Exists",
        text: error.response.data.message,
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Update failed. Please try again.",
      });
    }
  }
};


  return (
    <div className="modal">
      <div className="modal-content" style={{ position: "relative" }}   >
      <div style={{ position: "absolute", top: "10px", right: "10px" }}>
    <button className="close-btn" onClick={onClose}>
      &times;
    </button>
  </div>

        <h3>Edit Unit Of Measurement</h3>
        <form className="vehicle-form" onSubmit={handleEditSubmit}>

        <div className="form-row">
              <div className="form-group">
                <label>UOM Code :</label>
                <input type="text" name="code" value={editFormData.code} onChange={handleEditChange} readOnly/>
              </div>
             
            </div>

            <div className="form-row">
            <div className="form-group">
                <label>UOM Short Name :</label>
                <input type="text" name="name" value={editFormData.name} onChange={handleEditChange} />
              </div>
            </div>

            <div className="form-row">
            <div className="form-group">
                <label>UOM Long Name :</label>
                <input type="text" name="longName" value={editFormData.longName} onChange={handleEditChange} />
              </div>
            </div>

            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                 Update
              </button>
            </div>
           
            </form>

      </div>
    </div>
  );
};

export default EditUomModal;
